import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [LocationVarKey.PurchaseMonthlyPayments1, LocationVarKey.PurchaseMonthlyPayments2];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Monthly Pricing
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.PurchaseMonthlyPayments1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.PurchaseMonthlyPayments2}
        enableSwitchVar={LocationVarKey.PurchaseMonthlyPayments2Enabled}
      />
    </>
  );
}
